import { createSlice } from '@reduxjs/toolkit';

import { getFormPath_v2 } from 'utils/getFormPath_v2';

export interface FormCounter {
    screen: number;
    no_screens: number;
    purpose: string;
    fulfilledTables: { [key: string]: boolean };
    showSpouse: boolean;
    canEnableSubmitButton: boolean;
}

const initialState: FormCounter = {
    screen: 1,
    no_screens: 8,
    purpose: '',
    fulfilledTables: {},
    showSpouse: false,
    canEnableSubmitButton: false,
};

export const formCounterSlice = createSlice({
    name: 'formCounter',
    initialState,
    reducers: {
        next: (state) => {
            state.screen += 1;
        },
        prev: (state) => {
            state.screen -= 1;
        },
        set: (state, action) => {
            state.screen = action.payload;
        },
        initScreen: (state) => {
            state.screen = 1;
        },
        setPurpose: (state, action) => {
            state.purpose = action.payload;
            state.no_screens = getFormPath_v2(state.purpose).length;
        },
        setNumberForms: (state, action) => {
            state.no_screens = action.payload;
        },
        setShowSpouse: (state) => {
            state.showSpouse = !state.showSpouse;
        },
        setFulfilledTables: (state, action) => {
            state.fulfilledTables = action.payload;
        },
        setCanEnableSubmitButton: (state, action) => {
            state.canEnableSubmitButton = action.payload;
        },
    },
});
